import axios from '@/libs/axios'
import { handleCatch, mapDropdown } from '@/utils'
import { ApiCode } from '@/const/api'

export default {
  async getSyllabuses(params) {
    try {
      const { data } = await axios.get('uni/syllabus', { params })
      if (data.code === ApiCode.SUCCESS) {
        return {
          records: data.data.records,
          total: data.data.total,
        }
      }
    } catch (e) {
      handleCatch(e)
    }
    return { records: [], total: 0 }
  },

  async createSyllabus(params) {
    try {
      const { data } = await axios.post('uni/syllabus', params)
      return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
    } catch (e) {
      handleCatch(e)
    }
    return { isSuccessful: false, message: 'Có lỗi xảy ra khi tạo đề cương' }
  },

  async updateSyllabus(params) {
    try {
      const { data } = await axios.put(`uni/syllabus/${params.id}`, params)
      return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
    } catch (e) {
      handleCatch(e)
    }
    return { isSuccessful: false, message: 'Có lỗi xảy ra khi cập nhật đề cương' }
  },

  async deleteSyllabus(id) {
    try {
      const { data } = await axios.delete(`uni/syllabus/${id}`)
      return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
    } catch (e) {
      handleCatch(e)
    }
    return { isSuccessful: false, message: 'Có lỗi xảy ra khi xoá đề cương' }
  },

  async importSyllabus(params) {
    try {
      const { data } = await axios.post('uni/syllabus/importSyllabus', { params })
      return data
    } catch (e) {
      handleCatch(e)
    }
    return null
  },

  async getSyllabusStructure(params) {
    try {
      const { data } = await axios.get('uni/syllabus/structure', { params })
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
    return []
  },

  async saveSyllabusStructure(params) {
    try {
      const { data } = await axios.post('uni/syllabus/structure/save', params)
      return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
    } catch (e) {
      handleCatch(e)
    }
    return { isSuccessful: false, message: 'Có lỗi xảy ra khi lưu cấu trúc đề cương' }
  },
  async getGeneralScores() {
    try {
      const response = await axios.get('uni/generalScores/selection')
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        const { generalScore } = data.data
        return generalScore
      }
    } catch (e) {
      handleCatch(e)
    }
    return []
  },
  async getComponentScoresByGeneralScoreId(params) {
    try {
      const response = await axios.get('uni/componentScores/selection', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        const { componentScore } = data.data
        return componentScore
      }
    } catch (e) {
      handleCatch(e)
    }
    return []
  },
}
